module.exports = __webpack_public_path__ + "img/yuangong1.82e92d3b.jpg";